import Vue from 'vue';
import VueRouter from 'vue-router';

import { routes } from './routes';
import store from './stores/store';
import './assets/styles/app.scss'

import App from './App.vue';

Vue.use(VueRouter);

import VueSimpleAlert from "vue-simple-alert"
Vue.use(VueSimpleAlert)

import feather from 'vue-icon'
import './registerServiceWorker'
Vue.use(feather, 'v-icon')



//firebaseListener(authStatusChange);

// function authStatusChange(loggedIn, user) {
// 	if (store) {
// 		store.commit('AUTH_STATUS_CHANGE');
// 		if (user) {
// 			store.dispatch('getShoppingCart', {uid: user.uid, currentCart: store.getters.cartItemList});
// 		}
// 	}
// }

const router = new VueRouter({
	mode: 'history',
	routes
});

// router.beforeEach((to, from, next) => {
//     if (to.onlyGuest && store.getters.isLoggedIn) {
//         next('/');
//     } else {
//         next();
//     }
// });


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})


